import messages from "@smartmixin/i18n/dist/translations/sv.json";

export default messages;
